import { getAuthClientType } from '@shared/constants/Keys';
import { useCurrentUserStore } from '@shared/hooks/state/CurrentUserContainer';
import useSignout from '@shared/hooks/useSignout';
import { useEffect } from 'react';
import { useAuthStore } from '../../hooks/state/AuthContainer';

const TokenRefresher = () => {
    const { signout } = useSignout();
    const REFRESH_MS = 25 * 60 * 1000; // 25 min

    useEffect(() => {
        const interval = setInterval(async () => {
            if (!useAuthStore.getState().isLoading) {
                const result = await useAuthStore.getState().getNewToken();
                const isAdmin = getAuthClientType() == 'admin';
                if (isAdmin && result.resultType !== 'Ok') {
                    signout();
                }

                // loadUserLicenseAccess has a fallback to storage
                await useCurrentUserStore.getState().loadUserLicenseAccess();

                // removing this to not force reconnect of signalr on refresh
                // publish('force-reconnect');
            }
        }, REFRESH_MS);

        return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }, []);

    return <></>;
};

export default TokenRefresher;
